import usersLoginTemplate from './login/template.html';
import usersLoginCtrl from './login';
import usersForgotPasswordTemplate from './forgotPassword/template.html';
import usersForgotPasswordCtrl from './forgotPassword';
import usersSignUpTemplate from './signUp/template.html';
import usersSignUpCtrl from './signUp';
import usersProfileTemplate from './profile/template.html';
import usersProfileCtrl from './profile';
import usersChangePasswordTemplate from './changePassword/template.html';
import usersChangePasswordCtrl from './changePassword';
import usersGettingStartedTemplate from './gettingStarted/template.html';
import usersGettingStartedController from './gettingStarted';
import usersMsTeamsTabTemplate from './msTeamsTab/template.html';
import usersMsTeamsTabController from './msTeamsTab';
import usersRegistrationTemplate from './registration/template.html';
import usersRegistrationCtrl from './registration';
import usersRegisterTemplate from './register/template.html';
import usersRegisterCtrl from './register';
import usersCertificationsTemplate from './certifications/template.html';
import usersCertificationsCtrl from './certifications';
import navTemplate from './nav/template.html';
import navCtrl from './nav';
import usersUpgradeTemplate from './upgrade/template.html';
import usersUpgradeCtrl from './upgrade';
import usersReadOnlyTemplate from './readOnly/template.html';
import usersReadOnlyCtrl from './readOnly';

const controllerAs = 'gettingStartedCtrl';

const authState = {
  url: '/auth?id_token&access_token&refresh_token&expires_in&token_type',
  stateName: 'AUTH',
  resolve: {
    redirect: /* @ngInject */ (ResolveClass, AuthClass) => {
      return AuthClass.authenticateCognito().then(() => ResolveClass.login());
    }
  },
  views: {
    root: {
      template: `<spinner color="'white'"></spinner>`
    }
  }
};

const authMsTeamsState = {
  url: '/msteamstab',
  stateName: 'MS Teams Tab',
  views: {
    root: {
      template: usersMsTeamsTabTemplate,
      controller: usersMsTeamsTabController,
      controllerAs: 'usersMsTeamsTabCtrl'
    }
  }
};

const authMsTeamsConsentStartState = {
  url: '/msteamstab/consent_start',
  stateName: 'MS Teams Tab Consent Start',
  resolve: {
    MsTeamsClass: 'MsTeamsClass',
    redirect: /* @ngInject */ MsTeamsClass => {
      return MsTeamsClass.consentPopupStart().catch(() => {});
    }
  }
};

const authMsTeamsConsentEndState = {
  url: '/msteamstab/consent_end',
  stateName: 'MS Teams Tab Consent End',
  resolve: {
    MsTeamsClass: 'MsTeamsClass',
    redirect: /* @ngInject */ MsTeamsClass => {
      return MsTeamsClass.consentPopupEnd().catch(() => {});
    }
  }
};

const usersGettingStartedState = {
  url: '/getting-started',
  stateName: 'Getting Started',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: usersGettingStartedTemplate,
      controller: usersGettingStartedController,
      controllerAs
    }
  }
};

const usersLoginState = {
  url: '/?email&temp&company_id',
  stateName: 'Login',
  params: {
    company_id: {
      squash: true,
      type: 'int',
      value: 1
    },
    email: {
      value: 'false',
      squash: true
    },
    temp: {
      value: 'false',
      squash: true
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ ResolveClass => {
      return ResolveClass.redirect().catch(() => {});
    }
  },
  views: {
    root: {
      template: usersLoginTemplate,
      controller: usersLoginCtrl,
      controllerAs: 'usersLoginCtrl'
    }
  }
};

const usersForgotPasswordState = {
  url: '/password',
  stateName: 'Password',
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ ResolveClass => ResolveClass.redirect()
  },
  views: {
    root: {
      template: usersForgotPasswordTemplate,
      controller: usersForgotPasswordCtrl,
      controllerAs: 'usersForgotPasswordCtrl'
    }
  }
};

const usersSignUpState = {
  url: '/signup?company_id',
  params: {
    company_id: {
      squash: true,
      type: 'int',
      value: 1
    }
  },
  stateName: 'Signup',
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ ResolveClass => ResolveClass.redirect()
  },
  views: {
    'root@': {
      template: usersSignUpTemplate,
      controller: usersSignUpCtrl,
      controllerAs: 'usersSignUpCtrl'
    }
  }
};

const usersLogoutState = {
  url: '/logout',
  stateName: 'Log out',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    root: {
      template: ''
    }
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    logout: /* @ngInject */ ResolveClass => ResolveClass.logout()
  }
};

const usersProfileState = {
  url: '/profile',
  stateName: 'My Profile',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/users/:id/settings/profiles'),
  },
  views: {
    a: {
      template: usersProfileTemplate,
      controller: usersProfileCtrl,
      controllerAs: 'userProfileCtrl'
    }
  }
};

const usersCertificationsState = {
  url: '/certifications',
  stateName: 'Certifications',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/users/:id/settings/certifications'),
  },
  views: {
    a: {
      template: usersCertificationsTemplate,
      controller: usersCertificationsCtrl,
      controllerAs: 'UserCertificationsCtrl'
    }
  }
};

const auth0State = {
  url: '/auth0',
  stateName: 'Login',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ (ResolveClass, AuthClass) => {
      return AuthClass.authenticateAuth0().then(() => ResolveClass.login());
    }
  },
  views: {
    root: {
      template: `<spinner color="'white'"></spinner>`
    }
  }
};

const usersChangePasswordState = {
  url: '/password',
  stateName: 'Change Password',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    a: {
      template: usersChangePasswordTemplate,
      controller: usersChangePasswordCtrl,
      controllerAs: 'usersChangePasswordCtrl'
    }
  }
};

const usersRegistrationState = {
  url: '/registration?email',
  stateName: 'Signup',
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ ResolveClass => ResolveClass.redirect()
  },
  views: {
    'root@': {
      template: usersRegistrationTemplate,
      controller: usersRegistrationCtrl,
      controllerAs: 'UsersRegistrationCtrl'
    }
  }
};

const usersRegisterState = {
  url: '/register?company_id',
  params: {
    company_id: {
      squash: true,
      type: 'int',
      value: 1
    }
  },
  stateName: 'Sign In / Sign Up',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    redirect: /* @ngInject */ ResolveClass => ResolveClass.redirect(false)
  },
  views: {
    'a@app': {
      template: usersRegisterTemplate,
      controller: usersRegisterCtrl,
      controllerAs: 'UsersRegisterCtrl'
    }
  }
};

const userSettings = {
  url: '/settings',
  stateName: 'Settings',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: navTemplate,
      controller: navCtrl,
      controllerAs: 'NavCtrl'
    }
  }
};

const usersUpgradeState = {
  url: '/upgrade?product',
  params: {
    product: {
      type: 'string',
      value: undefined,
      squash: true
    }
  },
  stateName: 'Upgrade',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin();
    }
  },
  views: {
    'a@app': {
      template: usersUpgradeTemplate,
      controller: usersUpgradeCtrl,
      controllerAs: 'UsersUpgradeCtrl'
    }
  }
};

const usersReadOnlyState = {
  url: '/readOnly?product',
  params: {
    product: {
      type: 'string',
      value: undefined,
      squash: true
    }
  },
  stateName: 'ReadOnly',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    refresh: /* @ngInject */ ResolveClass => {
      return ResolveClass.refreshLogin();
    }
  },
  views: {
    'a@app': {
      template: usersReadOnlyTemplate,
      controller: usersReadOnlyCtrl,
      controllerAs: 'UsersReadOnlyCtrl'
    }
  }
};

const usersCpeRequestsState = {
  url: '/cpe-requests?search&page&pageSize',
  stateName: 'CPE Requests',
  data: {
    specialClass: 'fixed-sidebar'
  },
  reloadOnSearch: false,
  params: {
    search: {
      value: undefined,
      type: 'string'
    },
    pageSize: {
      type: 'int',
      value: undefined
    },
    page: {
      type: 'int',
      value: undefined
    }
  },
  views: {
    'a@app': {
      template: '<cpe-requests></cpe-requests>'
    }
  }
};

export {
  authState,
  auth0State,
  authMsTeamsState,
  authMsTeamsConsentStartState,
  authMsTeamsConsentEndState,
  usersCpeRequestsState,
  usersLoginState,
  usersForgotPasswordState,
  usersSignUpState,
  usersLogoutState,
  usersProfileState,
  usersCertificationsState,
  usersChangePasswordState,
  usersGettingStartedState,
  usersRegistrationState,
  usersRegisterState,
  userSettings,
  usersUpgradeState,
  usersReadOnlyState,
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/index.js